<template>
  <div class="column is-half">
    <div class="data-item">
      <img src="/static/img/icons/delete.svg" class="delete-icon" @click="deleteDataForClients(data.id)"/>
      <b-field>
        <b-input v-model="data.name" placeholder="Введите название" @change="handleUpdate"/>
      </b-field>
      <span class="link" @click="addFile" v-if="!data.file">Добавить файл</span>
      <span v-else>
        <span class="link">{{data.file | path }}</span>
        <span class="delete-file" @click="deleteDataForClientsFile(data.id)">X</span>
      </span>
      <input type="file" @change='loadFile' hidden ref="loadFile"/>
      <div class="switch">
        <b-switch v-model='data.isHidden' @change="handleUpdate">Скрыть с сайта</b-switch>
      </div>
      <div class="centered">
        <button class="button save-content" @click="handleSave()" :disabled="disabled">{{ disabled ? 'Идет сохранение...' : 'СОХРАНИТЬ' }}</button>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'

  export default {
    name: 'SoftItem',
    data () {
      return {
        updateTimer: 0,
        disabled: false
      }
    },
    props: {
      data: {
        type: Object,
        required: true
      }
    },
    methods: {
      ...mapActions(['updateDataForClients', 'deleteDataForClients', 'loadDataForClientsFile', 'saveDataForClients']),
      handleUpdate () {
        this.updateDataForClients(this.data)
      },
      handleSave () {
        this.disabled = true
        this.saveDataForClients(this.data)
        .then(() => {
          this.disabled = false
          this.$toast.open({ message: 'Сохранено' })
        })
      },
      addFile () {
        this.$refs.loadFile.click()
      },
      loadFile (e) {
        const formData = new FormData()
        const file = e.target.files[0]
        formData.set('document', file)
        this.data.newFile = formData
        this.data.file = file.name
        this.handleUpdate()
        this.$forceUpdate()
      },
      deleteDataForClientsFile () {
        delete this.data.newFile
        this.data.file = ''
        this.handleUpdate()
        this.$forceUpdate()
      }
    },
    filters: {
      path (path) {
        return path.split('/').pop()
      }
    }
  }
</script>

<style scoped>
.data-item {
  background: #eee;
  padding: 20px;
  position: relative;
}
.delete-icon {
  top: -8px;
  right: -8px;
}
.delete-file {
  color: gray;
  font-size: 20px;
  vertical-align: middle;
  margin: 0 0 0 7px;
  font-family: monospace;
  cursor: pointer;
}
.switch {
  margin: 10px 0 0;
}
.save-content {
  margin: 20px 0 10px;
}
</style>



// WEBPACK FOOTER //
// SoftItem.vue?0c50964e